import {AfterViewInit, Directive, ElementRef} from '@angular/core';
import {AgencyConfigService} from "../services/AgencyConfigService";

@Directive({
  selector: '[agencyLogo]'
})
export class AgencyLogoDirective implements AfterViewInit {

  constructor(private imageRef: ElementRef,
              private agencyConfigService: AgencyConfigService) {
  }

  ngAfterViewInit(): void {
    const img = new Image();
    let src = this.imageRef.nativeElement.getAttribute('src');

    if (this.isEmpty(src)) {
      this.setImage(this.agencyConfigService.getAgencyConfigData().logo);
    } else {
      img.onload = () => {
        this.setImage(src);
      };

      img.onerror = () => {
        // Set a placeholder image
        this.setImage(this.agencyConfigService.getAgencyConfigData().logo);
      };

      if (src) {
        img.src = src;
      }
    }
  }

  private setImage(src: any) {
    this.imageRef.nativeElement.setAttribute('src', src);
  }

  isEmpty(str: any) {
    return (!str || str.length === 0 );
  }
}



// WEBPACK FOOTER //
// ./src/directive/agency-logo.directive.ts